import parseHTML from "./dom/funciones/parse_html";
import { unaVez } from "./eventos";
var popup = parseHTML("<div class=\"popup-cookies\" role=\"banner\">\n    <div class=\"popup-cookies-texto\">\n        Utilizamos cookies propias y de terceros para mejorar nuestros servicios.\n        Si haces clic en ACEPTAR, consideramos que aceptas su uso.\n        Puedes obtener m\u00E1s informaci\u00F3n en la \n        <a href=\"/condiciones-de-uso/\" target=\"_blank\">Pol\u00EDtica de cookies</a>.\n    </div>\n    <div class=\"popup-cookies-botones\">\n        <button class=\"popup-cookies-aceptar\">\n            Aceptar\n        </button><button class=\"popup-cookies-rechazar\">\n            Rechazar\n        </button>\n    </div>\n</div>");
var ocultar = function () {
    unaVez(popup, 'transitionend', function () { return popup.remove(); });
    popup.classList.remove('is-visible');
};
var cookies = function (dataLayer, opciones) {
    var aceptado = localStorage.getItem('analytics'), fechaDeRechazo = parseInt(localStorage.getItem('fechaDeRechazo') || '0'), fechaDeAceptacion = parseInt(localStorage.getItem('fechaDeAceptacion') || '0');
    // Si se ha rechazado hace menos de 6 meses, no mostrar el popup
    if (aceptado === 'false' && fechaDeRechazo > Date.now() - 15768000000) {
        return;
    }
    // Si se ha aceptado hace menos de 6 meses, no mostrar el popup
    if (aceptado && fechaDeAceptacion > Date.now() - 15768000000) {
        window.gtag('consent', 'update', {
            'analytics_storage': 'granted',
            'ad_storage': 'denied'
        });
        dataLayer.push({ event: 'analytics-aceptado', 'analytics-aceptado': aceptado });
        return;
    }
    // Si no se ha aceptado o rechazado, mostrar el popup
    document.documentElement.appendChild(popup);
    var aceptar = popup.querySelector('.popup-cookies-aceptar'), rechazar = popup.querySelector('.popup-cookies-rechazar');
    if (opciones) {
        opciones.texto && (popup.querySelector('.popup-cookies-texto').innerHTML = opciones.texto);
        aceptar.innerHTML = opciones.aceptar;
        rechazar.innerHTML = opciones.rechazar;
    }
    aceptar.addEventListener('click', function () {
        localStorage.setItem('analytics', 'true');
        localStorage.setItem('fechaDeAceptacion', Date.now().toString());
        window.gtag('consent', 'update', {
            'analytics_storage': 'granted',
            'ad_storage': 'denied'
        });
        dataLayer.push({ event: 'analytics-aceptado', 'analytics-aceptado': 'true' });
        ocultar();
    });
    rechazar.addEventListener('click', function () {
        localStorage.setItem('analytics', 'false');
        localStorage.setItem('fechaDeRechazo', Date.now().toString());
        window.gtag('consent', 'update', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied'
        });
        dataLayer.push({ event: 'analytics-aceptado', 'analytics-aceptado': 'false' });
        ocultar();
    });
    setTimeout(function () { return popup.classList.add('is-visible'); });
};
export default cookies;
